
import { Dealer } from "@/types/dealer";
import { useDealersByCity } from "./useDealersByCity";
import { isSSR } from "@/lib/isSSR";
import { useEmbeddedDealerData } from "./useEmbeddedDealerData";

/**
 * Hook that combines embedded, server-side, and client-side dealers by city data fetching
 * Uses embedded data if available, then falls back to server-side data, and finally to client-side fetching
 */
export function useHydratedDealersByCity() {
  // Get the client-side dealer data
  const dealersByCityData = useDealersByCity();
  
  // Get embedded dealer data from HTML
  const { dealerData, isLoading: embeddedLoading } = useEmbeddedDealerData();
  
  // Determine which data to use - prioritize embedded data, then fall back to client-side data
  const cityDealers = (dealerData && dealerData.dealers && dealerData.dealers.length > 0) 
    ? dealerData.dealers 
    : dealersByCityData.cityDealers;
    
  // Safely access window object only on client-side
  const formattedCity = !isSSR() && typeof window !== 'undefined' && (window as any).__SERVER_FORMATTED_CITY__ 
    ? (window as any).__SERVER_FORMATTED_CITY__ 
    : dealersByCityData.formattedCity;
    
  // Ensure loading state is properly calculated from both sources
  // Use OR operator to make sure isLoading is true if either source is loading
  const isLoading = embeddedLoading || dealersByCityData.isLoading;
  
  return {
    ...dealersByCityData,
    cityDealers,
    formattedCity,
    isLoading
  };
}
